<template>
    <div class="user-invoice-form">
        <b-form-group class="mt-4 border rounded-pill rilievo-ombra-interna p-3">
            <b-form-radio-group name="invoiceType" class="d-flex justify-content-around"
                                v-model="invoiceData.invoiceType">
                <b-form-radio value="person">{{ $t("Privato") }}</b-form-radio>
                <b-form-radio value="company">{{ $t("Società") }}</b-form-radio>
                <b-form-radio value="individual">{{ $t("Ditta individuale") }}</b-form-radio>
            </b-form-radio-group>
        </b-form-group>
        <!-- Ragione sociale e codice fiscale -->
        <div class="form-row">
            <div class="col-sm-6 mb-3">
                <label for="invoiceRS" v-if="isPerson">
                    {{ $t("Cognome e nome") }} <span class="text-danger">*</span>
                </label>
                <label for="invoiceRS" v-if="!isPerson">
                    {{ $t("Ragione sociale") }} <span class="text-danger">*</span>
                </label>
                <validation-provider rules="required" v-slot="{ errors }">
                    <b-form-input type="text" name="invoiceRS" id="invoiceRS" v-model.trim="invoiceData.ragioneSociale"
                                  class="form-control rounded-pill rilievo-ombra-interna"></b-form-input>
                    <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
            </div>
            <div class="col-sm-6 mb-3">
                <label for="invoiceCF">
                    {{ $t("Codice fiscale") }}&nbsp;<span class="text-danger">*</span>
                </label>
                <validation-provider :rules="invoiceCFRules" v-slot="{ errors }">
                    <b-form-input type="text" name="invoiceCF" id="invoiceCF" v-model="invoiceData.codiceFiscale"
                                  class="form-control rounded-pill rilievo-ombra-interna"></b-form-input>
                    <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </div>
        <!-- Partita iva e codice identificativo -->
        <div class="form-row" v-if="!isPerson">
            <div class="col-sm-6 mb-3">
                <label for="invoicePiva">
                    {{ $t("Partita IVA") }}&nbsp;<span class="text-danger">*</span>
                </label>
                <validation-provider rules="required|validVat" v-slot="{ errors }" vid="invoicePiva">
                    <b-form-input type="text" name="invoicePiva" id="invoicePiva" v-model="invoiceData.piva"
                                  class="form-control rounded-pill rilievo-ombra-interna"></b-form-input>
                    <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
            </div>
            <div class="col-sm-6 mb-3">
                <label for="invoiceCI">
                    {{ $t("Codice identificativo") }}
                </label>
                <b-form-input type="text" name="invoiceCI" id="invoiceCI" v-model="invoiceData.codiceIdentificativo"
                              class="form-control rounded-pill rilievo-ombra-interna"></b-form-input>
            </div>
        </div>
        <!-- Pec -->
        <div class="form-row">
            <div class="col-sm-6 mb-3">
                <label for="invoicePec">
                    {{ $t("PEC") }}
                </label>
                <validation-provider rules="email" v-slot="{ errors }">
                    <b-form-input type="email" name="invoicePec" id="invoicePec" v-model="invoiceData.pec"
                                  class="form-control rounded-pill rilievo-ombra-interna"></b-form-input>
                    <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </div>
        <!-- Nazione e provincia -->
        <div class="form-row">
            <div class="col-sm-6 mb-3">
                <label for="invoiceNazione">
                    {{ $t("Nazione") }} <span class="text-danger">*</span>
                </label>
                <validation-provider rules="required" v-slot="{ errors }">
                    <select name="invoiceNazione" id="invoiceNazione" v-model="invoiceData.nazione"
                            class="form-control rounded-pill rilievo-ombra-interna">
                        <option value="">{{ $t("Seleziona nazione") }}</option>
                        <option value="Italia">{{ $t("Italia") }}</option>
                    </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
            </div>
            <div class="col-sm-6 mb-3">
                <label for="invoiceProvincia">
                    {{ $t("Provincia") }} <span class="text-danger">*</span>
                </label>
                <validation-provider rules="required" v-slot="{ errors }">
                    <select name="invoiceProvincia" id="invoiceProvincia" v-model="invoiceData.provincia"
                            class="form-control rounded-pill rilievo-ombra-interna" @change="onChangeInvoiceProvince"
                            ref="invoice-province-select">
                        <option value="">{{ $t("Seleziona Provicia") }}</option>
                        <option v-for="province in provinces" v-bind:value="province.Sigla" v-bind:key="province.Sigla">
                            {{ province.Provincia }}
                        </option>
                    </select>
                    <span class="text-danger">{{ errors ? errors[0] : "" }}</span>
                </validation-provider>
            </div>
        </div>
        <!-- Comune e cap -->
        <div class="form-row">
            <div class="col-sm-6 mb-3">
                <label for="invoiceCitta">
                    {{ $t("Città") }} <span class="text-danger">*</span>
                </label>
                <validation-provider rules="required" v-slot="{ errors }">
                    <select name="invoiceCitta" id="invoiceCitta" v-model="invoiceData.citta" ref="invoice-city-select"
                            class="form-control rounded-pill rilievo-ombra-interna" @change="onChangeInvoiceCity">
                        <option value="">{{ $t("Seleziona Città") }}</option>
                        <option v-for="(zips, city) in cities" v-bind:value="city" v-bind:key="city">
                            {{ city }}
                        </option>
                    </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
            </div>
            <div class="col-sm-6 mb-3">
                <label for="invoiceCap">
                    {{ $t("CAP") }} <span class="text-danger">*</span>
                </label>
                <validation-provider rules="required" v-slot="{ errors }">
                    <select name="invoiceCap" id="invoiceCap" v-model="invoiceData.cap"
                            class="form-control rounded-pill rilievo-ombra-interna" ref="invoice-zip-select">
                        <option value="">{{ $t("Seleziona CAP") }}</option>
                        <option v-for="zip in zips" v-bind:value="zip.cap" v-bind:key="zip.cap">
                            {{ zip.cap }}
                        </option>
                    </select>
                    <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </div>
        <!-- Indirizzo e telefono -->
        <div class="form-row">
            <div class="col-sm-6 mb-3">
                <label for="invoiceIndirizzo">
                    {{ $t("Indirizzo") }} <span class="text-danger">*</span>
                </label>
                <validation-provider rules="required" v-slot="{ errors }">
                    <b-form-input type="text" class="form-control rounded-pill rilievo-ombra-interna"
                                  id="invoiceIndirizzo" name="invoiceIndirizzo"
                                  v-model.trim="invoiceData.indirizzo"></b-form-input>
                    <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
            </div>
            <div class="col-sm-6 mb-3">
                <label for="invoiceTel">
                    {{ $t("Telefono") }}
                </label>
                <validation-provider v-slot="{ errors }">
                    <b-form-input type="tel" name="invoiceTel" id="invoiceTel" v-model.trim="invoiceData.tel"
                                  class="form-control rounded-pill rilievo-ombra-interna"></b-form-input>
                    <span class="text-danger">{{ errors[0] }}</span>
                </validation-provider>
            </div>
        </div>
    </div>
</template>

<script>
    import {ValidationProvider} from "vee-validate";

    export default {
        name: "UserInvoiceForm",
        components: {ValidationProvider},
        props: ["invoiceData", "invoiceProvinces", "invoiceCities", "invoiceZips"],
        data: function () {
            return {
                provinces: [],
                cities: [],
                zips: []
            }
        },
        computed: {
            isPerson() {
                return this.invoiceData.invoiceType === "person";
            },
            isCompany() {
                return this.invoiceData.invoiceType === "company";
            },
            invoiceCFRules() {
                return this.isCompany ? {required: true, confirmed: "invoicePiva"} : {
                    required: true,
                    validTaxCode: true
                };
            }
        },
        mounted() {
            this.provinces = this.invoiceProvinces;
            this.cities = this.invoiceCities;
            this.zips = this.invoiceZips;
        },
        methods: {
            onChangeInvoiceProvince() {
                let _this = this;
                _this.$refs["invoice-province-select"].disabled = true;
                _this.$refs["invoice-city-select"].disabled = true;
                _this.$refs["invoice-zip-select"].disabled = true;
                this.$api
                    .getItalyCities(this.invoiceData.provincia)
                    .then(result => {
                        _this.cities = result.cities;
                        _this.onChangeInvoiceCity();
                        _this.$refs["invoice-province-select"].disabled = false;
                        _this.$refs["invoice-city-select"].disabled = false;
                        _this.$refs["invoice-zip-select"].disabled = false;
                    })
                    .catch(error => {
                        console.error("error in italyCities" + error);
                    });
            },
            onChangeInvoiceCity() {
                if (this.cities[this.invoiceData.citta]) {
                    this.zips = this.cities[this.invoiceData.citta];
                    let userZipNotInList = this.zips.filter((cap) => {
                        return cap.cap === this.invoiceData.cap;
                    }).length === 0;
                    if (userZipNotInList) {
                        this.invoiceData.cap = this.zips[0].cap;
                    }
                } else {
                    this.zips = [];
                    this.invoiceData.citta = "";
                    this.invoiceData.cap = "";
                }
            }
        }
    }
</script>

<style scoped>

</style>
